import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { filter, take } from 'rxjs';

@Injectable()
export class FuseSplashScreenService {

    forceState = false;

    constructor(
        @Inject(DOCUMENT) private _document: any,
        private _router: Router
    ) {
        // Hide it on the first NavigationEnd event
        this._router.events
            .pipe(
                filter(event => event instanceof NavigationEnd),
                take(1)
            )
            .subscribe(() => {
                this.hide();
            });
    }


    forceShow(): void {
        this.forceState = true;
        this._document.body.classList.remove('fuse-splash-screen-hidden');
    }

    forceHide(): void {
        this.forceState = false;
        this._document.body.classList.add('fuse-splash-screen-hidden');
    }

    show(): void {
        this._document.body.classList.remove('fuse-splash-screen-hidden');
    }

    hide(): void {
        if (!this.forceState)
            this._document.body.classList.add('fuse-splash-screen-hidden');
    }
}
